<template>
  <form @submit.prevent="vLaunchDeliveryFormResearch">
    <div class="delivery-form-research">
      <div class="form-field">
        <label>{{$_('order_number')}}</label>
        <input @input="vSelectedStore('delivery_fncde', $event.target.value)" type="text" />
      </div>
      <div class="form-field">
        <label>{{$_('delivery_form_number')}}</label>
        <input @input="vSelectedStore('delivery_tnbl', $event.target.value)" type="text" />
      </div>
        <div class="form-field">
          <label>{{$_('invoice_number')}}</label>
          <input @input="vSelectedStore('delivery_tnfact', $event.target.value)" type="text" />
        </div>
        <div class="form-field">
          <label>{{$_('from')}}</label>
          <DatePicker @datepicker:select="vSelectedStore('delivery_tdate_bl', $event)" />
        </div>
      <div class="form-field">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from "@/common/components/widget/DatePicker";

export default {
  name: 'DeliveryFormResearch',
  components: {
    DatePicker
  },
  methods: {
    vLaunchDeliveryFormResearch() {
      this.$store.dispatch('facture/LAUNCH_RESEARCH', {launch_delivery_research: true});
      this.$store.dispatch('facture/SELECT', {key: 'reset_delivery_list', value: true});

      if(this.$route.query.order_id !== undefined && this.$route.query.order_id !== '') {
        this.$router.push({name: 'delivery'});
      }
    },
    vSelectedStore(key, value) {

      if(key === 'delivery_tdate_bl') {
        var DateTmp = value.split('/');
        DateTmp.reverse();
        value = DateTmp.join('');
      }

      this.$store.dispatch('facture/SELECT', {key, value});
    }
  }
};
</script>

<style scoped>
.delivery-form-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
</style>